<script lang="ts" setup>
import { twJoin } from "tailwind-merge";

import type { PxlIcon, PxlIconName } from "@/common/components/U/Icon";
import { iconBind } from "@/common/components/U/Icon";

const colors = {
  blue: "u-alert-blue",
  green: "u-alert-green",
  red: "u-alert-red",
  orange: "u-alert-orange",
};
const color_icons_map: Record<NonNullable<keyof typeof colors>, PxlIconName> = {
  blue: "info",
  green: "check",
  red: "warning",
  orange: "warning",
};

const emit = defineEmits(["close"]);
const props = withDefaults(
  defineProps<{
    title?: string;
    description?: string;
    closable?: boolean;
    icon?: PxlIcon;
    color?: keyof typeof colors;
  }>(),
  {
    color: "blue",
  }
);
const alertClass = computed(() => twJoin("u-alert", colors[props.color], props.description ? "py-4" : "py-2.5"));
const alertIcon = computed(() => props.icon || color_icons_map[props.color]);
</script>

<template>
  <div :class="alertClass">
    <div class="inline-flex items-center justify-start gap-3 self-stretch">
      <UIcon
        v-if="alertIcon"
        v-bind="iconBind(alertIcon, { class: 'text-base' })"
      />
      <div
        class="shrink grow basis-0 whitespace-pre-wrap text-sm font-bold leading-[1.188rem]"
        :class="props.title ? 'font-bold' : 'font-medium'"
      >
        {{ props.title || props.description }}
      </div>
      <div class="flex size-4 items-center justify-center">
        <UButton
          v-if="props.closable"
          title="Close"
          :padded="false"
          variant="clean"
          icon="close"
          @click="emit('close')"
        />
      </div>
    </div>
    <div
      v-if="props.description && props.title"
      class="inline-flex items-start justify-start self-stretch px-7"
    >
      <div class="shrink grow basis-0 whitespace-pre-wrap text-sm font-medium leading-[1.188rem]">
        {{ props.description }}
      </div>
    </div>
  </div>
</template>
